import routes from "./routes";
import FaultService from "./Service";

export {
  routes,
  FaultService
};
